import React, { useState } from 'react'
import { Box, Typography, Collapse, Table, TableContainer, TableRow, TableBody, TableHead, TableCell, Paper, Fab, CircularProgress } from '@mui/material';
import PopupDialogs from 'component/MuiReusableComponents/MuiPopupDialog/new-popup';
import MyButton from 'component/MuiReusableComponents/MuiButton/buttonMUI';
import { useSelector } from 'react-redux';
import SalarySlipPopup from 'component/EmployeeTabsViewDetails/TabsPanelComponent/salarySlipPopup';
import { salarySlipLoadingSelector } from 'store1/employees data/employeesData.slice.selector';
import { usersDataSelector } from 'store1/user login data/user.login.data.slice.slector';

const MySalarySlip = () => {
    const slipLoading = useSelector(salarySlipLoadingSelector);
    const salarySlipData = useSelector(s => s.EmployeesData.selfSalaryData);
    const [salarySlipPopup, setSalarySlipPopup] = useState(false);
    const [openSlipTable, setOpenSlipTable] = useState(false);
    const userData = useSelector(usersDataSelector);

    const monthNames = {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        "10": "October",
        "11": "November",
        "12": "December"
    };

    const downloadBase64PDF = (base64, fileName) => {
        if (!base64) return;

        try {
            const byteChar = atob(base64);
            const byteNum = new Array(byteChar.length);

            for (let i = 0; i < byteChar.length; i++) {
                byteNum[i] = byteChar.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNum);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName || "salary_slip.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading PDF:", error);
        }
    };
    return (
        <>
            <Box sx={{ p: 2 }}>
                <MyButton
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                        setSalarySlipPopup(true)
                        setOpenSlipTable(true)
                    }}
                >
                    Get salary slip
                </MyButton>

                <PopupDialogs
                    title="Salary Slip"
                    size="sm"
                    open={salarySlipPopup}
                    setOpen={setSalarySlipPopup}
                >
                    <SalarySlipPopup
                        empId={parseInt(userData.empId)}
                        onClose={() => setSalarySlipPopup(false)}
                    />
                </PopupDialogs>

                <Box sx={{ mt: 2 }}>
                    <Paper
                        sx={{
                            display: "flex",
                            margin: "15px 0px 5px 0px",
                            padding: "15px 25px 15px 15px",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            gutterBottom
                            sx={{ fontWeight: 600, flexGrow: 1 }}
                            textAlign="center !important"
                        >
                            Salary Slips
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Fab
                                sx={{ marginLeft: "15px" }}
                                color="primary"
                                title="Expand/Collapse"
                                aria-label="toggle"
                                size="small"
                                onClick={() => setOpenSlipTable(!openSlipTable)}
                            >
                                {openSlipTable ? "−" : "+"}
                            </Fab>
                        </Box>
                    </Paper>

                </Box>

                <Collapse in={openSlipTable} timeout="auto" unmountOnExit>
                    <Paper elevation={2} sx={{ bgcolor: 'white' }}>
                        <TableContainer>
                            <Table aria-label="salary slips table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell size="small" sx={{ fontWeight: 600 }}>Month</TableCell>
                                        <TableCell size="small" sx={{ fontWeight: 600 }}>File Name</TableCell>
                                        <TableCell size="small" sx={{ fontWeight: 600, textAlign: 'center' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {slipLoading ? (
                                        <TableRow>
                                            <TableCell colSpan={3} sx={{ textAlign: "center", py: 4 }}>
                                                <CircularProgress size={24} />
                                            </TableCell>
                                        </TableRow>
                                    ) : salarySlipData?.files?.length > 0 ? (
                                        salarySlipData.files.map((file, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{monthNames[String(file.month).padStart(2, "0")]}</TableCell>
                                                <TableCell>{file.fileName || "Unnamed File"}</TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <MyButton
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() =>
                                                            downloadBase64PDF(file.base64, file.fileName)
                                                        }
                                                    >
                                                        Download
                                                    </MyButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} sx={{ textAlign: 'center', py: 3 }}>
                                                <Typography color="text.secondary">
                                                    No salary slips available.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Collapse>
            </Box>
        </>
    )
}

export default MySalarySlip;
